import VueI18n from '@/i18n/locale';
export default [
  {
    path: '/general/feedback-center',
    meta: {
      title: VueI18n.t('Gattaran_Feedback__OHxt' /** 问题反馈 */),
    },
    async component(resolve) {
      resolve(await import('../pages/back-stage/index.vue'));
    },
  },
];
